"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAnalyticEvent = exports.DefaultAnalyticElement = exports.DefaultContentElement = void 0;
exports.getAnalyticEventFactory = getAnalyticEventFactory;
exports.setAnalyticEventFactory = setAnalyticEventFactory;
const event_1 = require("./event");
let factory = {
    async createEvent(event) {
        return new DefaultAnalyticEvent(event, new DefaultAnalyticElement(event.element, event.element ? (event.element.extras || {}) : {}, event.element && event.element.content ? event.element.content.map((c) => new DefaultContentElement(c)) : []));
    },
};
function getAnalyticEventFactory() {
    return factory;
}
function setAnalyticEventFactory(newFactory) {
    factory = newFactory;
}
class DefaultContentElement extends event_1.ContentElement {
    constructor(element) {
        super();
        this.id = element.id;
        this.type = element.type;
        this.index = element.index;
        this.percent = element.percent;
    }
    clone() {
        return new DefaultContentElement({ id: this.id, type: this.type, index: this.index, percent: this.percent });
    }
}
exports.DefaultContentElement = DefaultContentElement;
class DefaultAnalyticElement extends event_1.AnalyticElement {
    constructor(element, extras, content) {
        super();
        this.element = element;
        this.extras = extras;
        this.content = content;
    }
    get id() {
        return this.element.id;
    }
    get type() {
        return this.element.type;
    }
    clone() {
        return new DefaultAnalyticElement(this.element, this.extras, this.content.map((c) => c.clone()));
    }
}
exports.DefaultAnalyticElement = DefaultAnalyticElement;
class DefaultAnalyticEvent extends event_1.AnalyticEvent {
    constructor(event, element) {
        super();
        this._created = new Date();
        this.event = event;
        this.element = element;
    }
    get type() {
        return this.event.type;
    }
    get created() {
        return this._created;
    }
    get name() {
        return this.event.type.toString();
    }
    toParameters() {
        const parameters = {
            type: this.type.toString(),
            element_id: this.element.id,
            element_type: this.element.type,
            created: this.created.toISOString(),
        };
        if (this.element.extras) {
            for (const key in this.element.extras) {
                parameters['extra_' + key] = this.element.extras[key];
            }
        }
        if (this.element.content) {
            let ix = 0;
            for (const content of this.element.content) {
                parameters['content_id_' + ix] = content.id;
                parameters['content_id_type_' + ix] = content.type;
                if (content.index !== undefined) {
                    parameters['content_id_index_' + ix] = content.index;
                }
                if (content.percent) {
                    parameters['content_id_percent_' + ix] = content.percent;
                }
                ix++;
            }
        }
        return parameters;
    }
    clone() {
        return new DefaultAnalyticEvent(this.event, this.element.clone());
    }
}
exports.DefaultAnalyticEvent = DefaultAnalyticEvent;
//# sourceMappingURL=factory.js.map